import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import CreditMemoRequestService from '../../../../Services/CreditMemo/CreditMemoRequestService';
import ErrorMessage from '../../../ErrorMessage';

export default class CreditMemoRequestStatusChangeSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    EntityId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    if (!this.props.EntityId) {
      this.setState({ selectValues: [] });
      return;
    }

    CreditMemoRequestService.GetNavigation(this.props.EntityId)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((creditMemoRequest) => {
          optValues.push({
            label: `${creditMemoRequest.name}`,
            value: creditMemoRequest.id,
            disabled: false,
          });
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('CMRSCS49');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
